module.exports = __webpack_public_path__ + "../resources/img/ic_re_lt_ef_layer_set_2_img.011c9d7b.svg";